import { buildTrboRequestUrl } from "../shared/Trbo/trbo-request-builder";
import { mapTrboResponseToProduktkarussellModel } from "../shared/Trbo/trbo-response-mapper";
import { IProduktkarussellModel } from "../models/i-product-carousel";
import { CreateSliderContent } from "./trbo-slider";
import { PromotionviewTracking } from "../functions/google-tracking";
import { SwiperSlider } from "./swiper-slider";

declare const __ucCmp: any;
declare const _trbo: any;
const trboId = "ryxCCtrEX";

export const RenderTrboDynamicSliders = async (): Promise<void> => {
	const carousels = document.querySelectorAll(".trbo_dynamic-slider__carousel");
	if (carousels && carousels.length > 0) {
		if ((window as { [key: string]: any }).__ucCmp !== undefined && (await __ucCmp.isInitialized())) {
			const details = await __ucCmp.getConsentDetails();

			if (!details.services[trboId].consent.given) {
				carousels.forEach((carousel: HTMLElement) => {
					const serverWrapper = carousel.querySelector(".swiper-wrapper-server") as HTMLElement;
					if (serverWrapper.childElementCount === 0) {
						carousel.style.display = "none";
					} else {
						serverWrapper.style.display = "";
					}
				});

				if (details.services[trboId].consent.given && (window as { [key: string]: any })._trbo === undefined) {
					setTimeout(() => {
						RenderTrboDynamicSliders();
					}, 100);
				}
			} else {
				carousels.forEach((carousel) => {
					const serverWrapper = carousel.querySelector(".swiper-wrapper-server") as HTMLElement;

					const trboSlot = carousel.getAttribute("data-trbo-slot");
					const carouselGuid = carousel.getAttribute("data-guid");
					const url = buildTrboRequestUrl(trboSlot);

					fetch(encodeURI(url))
						.then((response) => {
							response
								.json()
								.then((data) => {
									const model = mapTrboResponseToProduktkarussellModel(data) as IProduktkarussellModel;

									if (
										!model ||
										model.karussellItems.length === 0 ||
										carousel.querySelectorAll(`#product${carouselGuid}`).length === 0
									) {
										serverWrapper.style.display = "";

										return;
									}

									serverWrapper.remove();

									CreateSliderContent(model, carousel, true);

									/* scroll to the first slide , hacky */
									setTimeout(function() {
										SwiperSlider();
									}, 100);

									PromotionviewTracking();
								})
								.catch((error) => {
									console.log(error);
								});
						})
						.catch((error) => {
							console.log(error);
						});
				});
			}
		} else {
			setTimeout(() => {
				RenderTrboDynamicSliders();
			}, 100);
		}
	}
};

function hideSpinner(container: Element): void {
	const spinner = container.querySelector(".ajaxSpinner_Loading") as HTMLElement;
	const guid = container.getAttribute("data-guid");
	if (spinner) {
		spinner.classList.add("hide");
		container.querySelector(`#product${guid}`).remove();
	}
}
